import type { AiHtmlSectionState } from './aiHtmlSectionReducer';

const getIsLoading = ({
  aiHtmlSection,
}: {
  aiHtmlSection: AiHtmlSectionState;
}) => aiHtmlSection.isLoading;

const getAiHtmlSection = ({
  aiHtmlSection,
}: {
  aiHtmlSection: AiHtmlSectionState;
}) => aiHtmlSection.generatedSection;

export const aiHtmlSectionSelectors = {
  getIsLoading,
  getAiHtmlSection,
};
